import React from "react";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";

const ConsultantProfile = ({ profile }: { profile: any }) => {
  return (
    <Card
      title="Consultant Profile"
      style={{
        marginBottom: "20px",
        backgroundColor: "#0093E9",
        backgroundImage: "linear-gradient(160deg, #0093E9 0%, #80D0C7 100%)",
        borderRadius: "10px",
        padding: "20px",
        color: "#F0F0F0",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div
        style={{
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        }}
      >
        <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
          <strong style={{ color: "#FFD700" }}>Name:</strong>{" "}
          <span>{profile?.consultant_Name}</span>
        </p>
        <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
          <strong style={{ color: "#FFD700" }}>Email:</strong>{" "}
          <span>{profile?.consultant_Email_id}</span>
        </p>
        <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
          <strong style={{ color: "#FFD700" }}>Phone:</strong>{" "}
          <span>{profile?.consultant_Home_No}</span>
        </p>
        <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
          <strong style={{ color: "#FFD700" }}>Job Title:</strong>{" "}
          <span>{profile?.consultant_Job_Title}</span>
        </p>
        <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
          <strong style={{ color: "#FFD700" }}>Visa Type:</strong>{" "}
          <span>{profile?.visa_Name}</span>
        </p>
        <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
          <strong style={{ color: "#FFD700" }}>Employer:</strong>{" "}
          <span>{profile?.pO_Sub_Vendor_Company}</span>
        </p>
        <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
          <strong style={{ color: "#FFD700" }}>Employer POC:</strong>{" "}
          <span>{profile?.sub_Vendor_Contact_Person}</span>
        </p>
        {/* <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
          <strong style={{ color: "#FFD700" }}>Document:</strong>{" "}
          <span>{profile?.document}</span>
        </p> */}
      </div>
    </Card>
  );
};

export default ConsultantProfile;
